import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { motivationPopupOpenSelector } from '../../../selectors/newbuildingConsultant';
import { newbuildingChatOpenToggle, newbuildingOpenMotivationToggle } from '../../../serp/state/newbuildingConsultant';
import { trackConsultantMotivationPopupClick, trackConsultantMotivationPopupShown } from './analytics';
import { MotivationConsultantPopup } from '../../../serp/components/MotivationConsultantPopup';

export function MotivationConsultantPopupContainer() {
  const isOpen = useSelector(motivationPopupOpenSelector);
  const dispatch = useDispatch();
  const content = React.useMemo(
    () => ({
      title: 'Нужно найти квартиру\nв новостройке?',
      text: 'Консультанты Циан помогут быстро подобрать лучшее предложение',
      buttonText: 'Начать диалог',
    }),
    [],
  );

  React.useEffect(() => {
    if (isOpen) {
      trackConsultantMotivationPopupShown();
    }
  }, [isOpen]);

  const close = React.useCallback(() => dispatch(newbuildingOpenMotivationToggle(false)), []);
  const onClick = React.useCallback(() => {
    trackConsultantMotivationPopupClick();
    dispatch(newbuildingChatOpenToggle(true));
  }, []);

  if (!isOpen) {
    return null;
  }

  return <MotivationConsultantPopup content={content} onClick={onClick} onClose={close} />;
}
